export const FETCH_FG_PURITY_REQUEST = 'FETCH_FG_PURITY_REQUEST';
export const FETCH_FG_PURITY_SUCCESS = 'FETCH_FG_PURITY_SUCCESS';
export const FETCH_FG_PURITY_FAILURE = 'FETCH_FG_PURITY_FAILURE';

export const ADD_FG_PURITY_REQUEST = 'ADD_FG_PURITY_REQUEST';
export const ADD_FG_PURITY_SUCCESS = 'ADD_FG_PURITY_SUCCESS';
export const ADD_FG_PURITY_FAILURE = 'ADD_FG_PURITY_FAILURE';

export const UPDATE_FG_PURITY_REQUEST = 'UPDATE_FG_PURITY_REQUEST';
export const UPDATE_FG_PURITY_SUCCESS = 'UPDATE_FG_PURITY_SUCCESS';
export const UPDATE_FG_PURITY_FAILURE = 'UPDATE_FG_PURITY_FAILURE';

export const DELETE_FG_PURITY_REQUEST = 'DELETE_FG_PURITY_REQUEST';
export const DELETE_FG_PURITY_SUCCESS = 'DELETE_FG_PURITY_SUCCESS';
export const DELETE_FG_PURITY_FAILURE = 'DELETE_FG_PURITY_FAILURE';

export const FG_PURITY_FORM_ERROR = 'FG_PURITY_FORM_ERROR';
export const FG_PURITY_FORM_SUCCESS = 'FG_PURITY_FORM_SUCCESS';
export const SET_FG_PURITY_EDIT = 'SET_FG_PURITY_EDIT';
export const CLEAR_FG_PURITY_EDIT = 'CLEAR_FG_PURITY_EDIT'; 